import React from 'react';
import CommerceDocsPage from './CommerceDocsPage';

export default function QuotationsPage() {
  return <CommerceDocsPage mode="quotation" />;
}
